import { render, staticRenderFns } from "./Reportegeneral.vue?vue&type=template&id=27f0db8f&scoped=true"
import script from "./Reportegeneral.vue?vue&type=script&lang=js"
export * from "./Reportegeneral.vue?vue&type=script&lang=js"
import style0 from "./Reportegeneral.vue?vue&type=style&index=0&id=27f0db8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f0db8f",
  null
  
)

export default component.exports